export default function scrollIE() {
  const body = document.querySelector('body');
  const userAgent = window.navigator.userAgent.toLowerCase();

  if (
    userAgent.indexOf('msie') !== -1 ||
    userAgent.indexOf('trident') !== -1 ||
    userAgent.indexOf('edge') !== -1
  ) {
    body.addEventListener('mousewheel', (event) => {
      // デフォルトの設定値をOFFに切り替える
      event.preventDefault();
      const wd = event.wheelDelta;
      const csp = window.pageYOffset;
      window.scrollTo(0, csp - wd);
    });
  }
}
